import React from "react";
import { OrderGroupDetails } from "./details/OrderGroupDetails";
import { OrderGroupIndex } from "./index/OrderGroupIndex";
import { SHIP_FOR_ME_GROUPS } from "./orderGroupKinds";

/** List of Ship For Me order groups. */
export const ShipForMeGroupIndex: React.FC = () => <OrderGroupIndex kind={SHIP_FOR_ME_GROUPS} />;

/** Page of one Ship For Me order group. */
export const ShipForMeGroupDetails: React.FC = () => <OrderGroupDetails kind={SHIP_FOR_ME_GROUPS} />;
